import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api/Admin.api';
import { getToken, removeToken, storeToken } from '../utils/localStorage';

const AuthContext = createContext(null);

function useAuth() {
    return useContext(AuthContext);
}

function AuthProvider({ children }) {
    const navigate = useNavigate();
    const [token, setToken] = useState(getToken());
    const [error, setError] = useState('');

    const signin = (username, password, callback) => {
        return login(username, password)
            .then((response) => {
                const authToken = response?.token;

                if (!authToken) {
                    throw new Error('Token is missing in auth response');
                }

                storeToken(authToken);
                setToken(authToken);
                setError('');
                callback();
            })
            .catch(() => {
                setError('Неправильні логін або пароль');
            });
    };

    const logout = () => {
        removeToken();
        setToken(null);
        setError('');
        navigate('/login');
    };

    const value = { token, signin, logout, error };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export {
    AuthProvider,
    AuthContext,
    useAuth
};
